import React, { useEffect, useState } from 'react';
import Button from '@/components/atomics/Button';
import Icon from '@/components/atomics/Icons';
import Modal from '@/components/atomics/Modal';
import ActionsConfirm from '@/components/molecules/Actions/Confirm';
import Spinner from '@/components/atomics/Spinner';
import BukaIsolirForm from '@/components/molecules/Actions/BukaIsolir/Form';
import styles from './DashboardAction.module.scss';
import ActionsMessage from '@/components/molecules/Actions/Message';
import { useIsolirDevice, useUnpairDevice } from '@/hooks/useDevice';

const className = 'dashboard-action';

type DashboardActionProps = {
  access?: string[];
  disabled?: boolean;
  selectedDevices: any[];
  onSubmit?: () => void;
};

const DashboardAction: React.FC<DashboardActionProps> = ({ access, disabled = true, selectedDevices, onSubmit }) => {
  const [contentModal, setContentModal] = useState<React.ReactNode>();
  const [file, setFile] = useState<string | undefined>(undefined);
  
  const { mutate: unpairDevice, isPending: isLoadingUnpair } = useUnpairDevice(
    selectedDevices.map(({ deviceName, ...rest }) => rest));
  const { mutate: isolirDevice, isPending: isLoadingIsolir } = useIsolirDevice(
    selectedDevices.map(({ deviceName, ...rest }) => rest), file);

  useEffect(() => {
    if (isLoadingUnpair || isLoadingIsolir) {
      setContentModal(
        <Modal close={false} open={true}>
          <Spinner />
        </Modal>
      );
    }
  }, [isLoadingUnpair, isLoadingIsolir]);

  const handleConfirm = (action: string) => {
    let title = 'Konfirmasi Tindakan';
    let message = 'Apakah Anda yakin ingin melanjutkan tindakan ini?';
    let onConfirm: () => void = () => {};

    switch (action) {
      case 'isolir':
        title = 'Buka isolir';
        message = `Apakah Anda yakin ingin membuka isolir pada perangkat 
          ${selectedDevices.map((device) => device?.deviceName).join(',')}?`;
        onConfirm = () => {
          isolirDevice(undefined, {
            onSuccess: () => {
              handleSubmit('isolir');
            },
            onError: (error) => {
            },
          });
        };
        break;
      case 'hapus':
        title = 'Hapus Perangkat';
        message = `Perangkat akan 
          ${selectedDevices.map((device) => device?.deviceName).join(',')}
          dihapus secara permanen dari sistem Anda.
          Yakin ingin menghapus perangkat ini?`;
        onConfirm = () => {
          unpairDevice(undefined, {
            onSuccess: () => {
              handleSubmit('hapus');
            },
            onError: (error) => {
            },
          });
        };
        break;
      default:
        message = 'Action tidak dikenali';
    }

    setContentModal(
      <Modal close={false} open={true} onClose={() => setContentModal(undefined)}>
        <ActionsConfirm
          title={title}
          message={message}
          onConfirm={onConfirm}
          onCancel={() => setContentModal(undefined)}
        />
      </Modal>
    );
  };

  const handelClickAction = (action: string) => {
    let content: React.ReactNode;
    let title: string = 'Modal Title';

    switch (action) {
      case 'isolir':
        content = (
          <BukaIsolirForm
            onCancel={() => setContentModal(undefined)}
            onSubmit={(data) => {
              setFile(data?.fileBase64);
              handleConfirm('isolir');
            }}
          />
        );
        title = 'Buka Isolir';
        break;
      default:
        content = <div>Action tidak dikenali</div>;
    }
    setContentModal(
      <Modal
        close={true}
        open={true}
        onClose={() => {
          setContentModal(undefined);
        }}
        title={title}
      >
        {content}
      </Modal>
    );
  };

  const handleSubmit = (action: string) => {
    let title = '';
    let message = '';

    switch (action) {
      case 'isolir':
        title = 'Buka Isolir Perangkat Berhasil';
        message = 'Isolir pada perangkat telah berhasil dibuka dan perangkat kini dapat digunakan kembali.';
        break;
      case 'hapus':
        title = 'Hapus Perangkat Berhasil';
        message = 'Perangkat berhasil dihapus secara permanen dari sistem Anda.';
        break;
      default:
        message = 'Action tidak dikenali';
    }

    setTimeout(() => {
      setContentModal(
        <Modal close={false} open={true} onClose={() => {
          setContentModal(undefined);
        }}>
          <ActionsMessage title={title}
            message={message}
            onConfirm={() => {
              setContentModal(undefined);
              onSubmit?.();
            }} />
        </Modal>
      );
    }, 2000);
  };

  return (
    <>
      <div className={styles[className + '__buttons']}
        data-testid="dashboard-action">
        {
          access?.includes('unpair') && (
            <Button
              className={styles[className + '__button']}
              disabled={disabled}
              onClick={() => handleConfirm('hapus')}
              variant="secondary"
            >
              <Icon name="TrashX" />
              Hapus Perangkat
            </Button>
          )
        }
        {
          access?.includes('isolir') && (
            <Button
              className={styles[className + '__button']}
              disabled={disabled}
              onClick={() => handelClickAction('isolir')}
              variant="secondary"
            >
              <Icon name="LockOpen" />
              Buka Isolir
            </Button>
          )
        }
      </div>
      {
        contentModal
      }
    </>
  );
};

export default DashboardAction;
